<div class="alert-block" [ngClass]="{ 'shake-element': cardIsShake,
   'alert-blocker-map': currentRoute == '/map' || currentRoute == '/user' || currentRoute == '/'} ">
  <img src="../../../assets/access-block/access-block-icon.png" />
  <h3><b>A empresa possui pendências</b>
  </h3>
  <h3>
    Empresa com pendências, evite o bloqueio do sistema. Entre em contato com:
    <br>
    <mat-icon svgIcon="bx-fone"></mat-icon> <a
      href="https://wa.me/554133431122?text=Ol%C3%A1!%20Estou%20com%20o%20acesso%20ao%20sistema%20bloqueado%20por%20inadimpl%C3%AAncia%20e%20gostaria%20de%20regularizar%20a%20situa%C3%A7%C3%A3o."
      target="_blank">(41) 3343-1122</a>
    <br>
    Ou
    <br>
    <mat-icon svgIcon="bx-email"></mat-icon>
    <a href="mailto:financeiro&#64;smartgreen.net" target="_blank">financeiro&#64;smartgreen.net</a>
  </h3>
</div>